import { render } from "./ServiceAdd.vue?vue&type=template&id=51ecef7e"
import script from "./ServiceAdd.vue?vue&type=script&lang=js"
export * from "./ServiceAdd.vue?vue&type=script&lang=js"
script.render = render

export default script